import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import CdpEnterYourCarDetails from "./component";
import { getGuestToken, setProfileDetails } from "../../au.configuration/actions";
import { setRedirectionData } from "../../../au-c2b/au.desktop/components/trade-in-wrapper/actions";
import {createTradeIn, updateTradeIn, getTradeVehicleDetails, setUserPersonalDetails, getTradeInDetails} from "../checkout-info/actions";

const mapStateToProps = ({
    user: {
        secureToken,
        isLoggedIn,
        gaId,
        email: userEmail,
        mobile
    },
    checkout: {
        tradeInData
    },
    auc2bTradeIn: {
        redirectionData
    } = {}
}) => ({
    secureToken,
    isLoggedIn,
    tradeInData,
    gaId,
    redirectionData,
    userEmail,
    mobile
});

const mapDispatchToProps = (dispatch) => bindActionCreators({
    getGuestTokenConnect: getGuestToken,
    setProfileDetailsConnect: setProfileDetails,
    getTradeInDetailsConnect: getTradeInDetails,
    getTradeVehicleDetailsConnect: getTradeVehicleDetails,
    createTradeInConnect: createTradeIn,
    updateTradeInConnect: updateTradeIn,
    setUserPersonalDetailsConnect: setUserPersonalDetails,
    setRedirectionDataConnect: setRedirectionData
}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(CdpEnterYourCarDetails);
